import * as React from "react";
import { Input, Label } from "reactstrap";
import classnames from 'classnames';

class AgreementCheckboxField extends React.Component<any> {
  render() {
    const { componentLabel, className, disabled, value, onClick, ...props } = this.props;
    return (
        <div>
            <Input type="checkbox" disabled={disabled} checked={value} onClick={onClick} {...props} />
            <Label className={classnames("d-block", className, disabled && "disabled")}>
                {componentLabel}
            </Label>
        </div>
    );
  }
}

export default AgreementCheckboxField;
